import EditIcon from "@mui/icons-material/Edit";
import { Button, useNotify, useRecordContext, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import PreviousEducationSection from "../../ApprovedCandidacies/Enroll/PreviousEducationSection";

const toDateOnly = value => (value ? value.split("T")[0] : null);

const PreviousEducationEditDialog = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record?.id) return null;

  const handleConfirm = async data => {
    await dataProvider.customRequest(
      doctoralRequests.updateDoctorantPreviousEducation(record.id),
      {
        previousEducation: {
          ...data.previousEducation,
          diplomaDate: toDateOnly(data.previousEducation?.diplomaDate),
        },
      },
      "PUT",
    );
    notify("Данните за предходно образование са обновени успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Редакция на предходно образование"
      saveTitle="Запази"
      dialogSize="md"
      onConfirm={handleConfirm}
      defaultValues={{ previousEducation: record.previousEducation || {} }}
      triggerButton={
        <Button
          label="Редактирай"
          variant="outlined"
          size="small"
          startIcon={<EditIcon />}
        />
      }
    >
      <PreviousEducationSection />
    </FormModal>
  );
};

export default PreviousEducationEditDialog;
